//here we will keep all roles for the application
import { ADMIN_TOOLBAR_OPTIONS, USER_TOOLBAR_OPTIONS } from '@components/content-editor/constants.ts';

export const ROLES = {
    ADMIN: 'clientAdmin',
    TENANT_ADMIN: 'TenantAdmin',
    BLUEBYTE_ADMIN: 'blueByteAdmin',
    USER: 'clientUser',
    VESSEL_DASHBOARD_VIEWER: 'dashboardVesselViewer',
    FLEET_DASHBOARD_VIEWER: 'dashboardFleetViewer',
    CREW_ASSESSOR: 'CrewAssessor',
    OFFICE_ASSESSOR: 'OfficeAssessor',
};

export const ROLES_ACCESS_TOOLBAR_OPTIONS = {
    [ROLES.USER]: USER_TOOLBAR_OPTIONS,
    [ROLES.BLUEBYTE_ADMIN]: ADMIN_TOOLBAR_OPTIONS,
    [ROLES.ADMIN]: ADMIN_TOOLBAR_OPTIONS,
} as const;

/**
 * Highest priority first.
 * If user has many roles, the first matched role from this list wins.
 */
export const ROLES_PRIORITY = [ROLES.BLUEBYTE_ADMIN, ROLES.ADMIN, ROLES.USER] as const;

export const ALLOWED_ROLES = [
    ROLES.ADMIN,
    ROLES.TENANT_ADMIN,
    ROLES.BLUEBYTE_ADMIN,
    ROLES.USER,
    ROLES.VESSEL_DASHBOARD_VIEWER,
    ROLES.FLEET_DASHBOARD_VIEWER,
    ROLES.CREW_ASSESSOR,
    ROLES.OFFICE_ASSESSOR,
];

export const ADMIN_ROLES = [ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.BLUEBYTE_ADMIN];
export const VESSEL_DASHBOARD_ROLES = [...ADMIN_ROLES, ROLES.VESSEL_DASHBOARD_VIEWER];
export const FLEET_DASHBOARD_ROLES = [...ADMIN_ROLES, ROLES.FLEET_DASHBOARD_VIEWER];
export const ASSESSOR_ROLES = [...ADMIN_ROLES, ROLES.CREW_ASSESSOR, ROLES.OFFICE_ASSESSOR];

export const TENANT_CLIENT_BB_NAME = 'BlueByte';
export const TENANT_CLIENT_BB_ALIAS = 'admin-center';
